import { render } from "./CloseIconModal.vue?vue&type=template&id=cee5da0e"
import script from "./CloseIconModal.vue?vue&type=script&lang=js"
export * from "./CloseIconModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__